import { useEffect, useState } from "react";
import { db } from "firebase.js";
import { collection, getDocs } from "firebase/firestore";
import AdminControlCell from "Components/Admin/AdminControlCell";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const usersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(usersList);
      setFilteredUsers(usersList);
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    let results = [...users];

    if (filter === "admin") {
      results = results.filter((u) => u.adminFor);
    } else if (filter === "master") {
      results = results.filter((u) => u.master);
    }

    if (searchQuery) {
      const lower = searchQuery.toLowerCase();
      results = results.filter(
        (u) =>
          u.name?.toLowerCase().includes(lower) ||
          u.email?.toLowerCase().includes(lower)
      );
    }

    setFilteredUsers(results);
  }, [searchQuery, filter, users]);

  useEffect(() => {
    const fetchData = async () => {
      const userSnap = await getDocs(collection(db, "users"));
      const locationSnap = await getDocs(collection(db, "locations"));

      setUsers(userSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setLocations(
        locationSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    };

    fetchData();
  }, []);

  const refreshUsers = async () => {
    const snap = await getDocs(collection(db, "users"));
    setUsers(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };
  
  return (
    <div className="min-h-screen bg-gray-700 p-6 text-white">
      <h2 className="text-4xl font-semibold text-center mb-6">
        Gestion des Utilisateurs
      </h2>

      <div className="max-w-7xl mx-auto bg-gray-800 p-6 rounded-lg shadow-xl space-y-4">
        {/* Filters + Search */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <input
            type="text"
            placeholder="Rechercher par nom ou email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="px-4 py-2 rounded-md w-full md:w-1/2 bg-gray-700 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-amber-400"
          />

          <div className="flex space-x-2">
            <button
              onClick={() => setFilter("all")}
              className={`px-4 py-2 rounded ${
                filter === "all" ? "bg-amber-600" : "bg-gray-700"
              } hover:bg-amber-500 transition`}
            >
              Tous
            </button>
            <button
              onClick={() => setFilter("admin")}
              className={`px-4 py-2 rounded ${
                filter === "admin" ? "bg-amber-600" : "bg-gray-700"
              } hover:bg-amber-500 transition`}
            >
              Admins
            </button>
            <button
              onClick={() => setFilter("master")}
              className={`px-4 py-2 rounded ${
                filter === "master" ? "bg-amber-600" : "bg-gray-700"
              } hover:bg-amber-500 transition`}
            >
              Masters
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-gray-600 text-amber-300">
                <th className="p-2">Nom</th>
                <th className="p-2">Date de création</th>
                <th className="p-2">Email</th>
                <th className="p-2">Téléphone</th>
                <th className="p-2">Admin de la location</th>
                <th className="p-2">Master</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr key={user.id} className="border-b border-gray-600">
                <td className="p-2">{user.name || <i>—</i>}</td>
                <td className="p-2">
                  {user.createdAt
                    ? new Date(user.createdAt.seconds * 1000).toLocaleDateString(
                        "fr-FR",
                        {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        }
                      )
                    : <i>—</i>}
                </td>
                <td className="p-2">{user.email}</td>
                <td className="p-2">{user.phone}</td>
                <AdminControlCell user={user} locations={locations} refreshUsers={refreshUsers} />
                <td className="p-2">
                  {user.master ? (
                    <span className="text-orange-400">Oui</span>
                  ) : (
                    <span className="text-gray-400 italic">Non</span>
                  )}
                </td>
              </tr>
              ))}
              {filteredUsers.length === 0 && (
                <tr>
                  <td colSpan="4" className="p-4 text-center text-gray-400">
                    Aucun utilisateur trouvé.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
